import { useEffect, useState } from 'react';
import { WET_WELL_TAG_NAME, HEIGHT } from '../config';
import { AssetType } from 'src/types/assets';
import { convertToNumber, extractTimestampIfLevelExists } from '../utils';
import { useWebSockets } from 'src/contexts/webSocketsContext/websockets.context';

type useWetWellDataArgumentsTypes = {
  asset: AssetType;
  customerId: string | null;
};

export const useWaterLevelData = ({ asset }: useWetWellDataArgumentsTypes) => {
  const [waterLevel, setWaterLevel] = useState<number | null>(null);
  const [timestamp, setTimestamp] = useState<string | null>(null);
  const [unit, setUnit] = useState<string>('');

  const assetAssignedTag = asset?.assignedTags?.find(
    (tag) => tag?.tagName.toLowerCase() === WET_WELL_TAG_NAME
  );
  const { messages } = useWebSockets();
  const gatewayInputs = messages?.data?.data;

  const findInput = gatewayInputs?.find(
    (input: { id: string | undefined }) => input.id === assetAssignedTag?.assignedTagId
  );

  const assetProperty = asset?.assetProperties?.find((property) => property.name === HEIGHT);
  const alarms = asset?.assignedAlarmTags || [];

  useEffect(() => {
    if (findInput) {
      const toNumber = convertToNumber(findInput.value);
      const roundedWaterLevel = toNumber !== false ? Math.round(toNumber * 10) / 10 : -1;
      setWaterLevel(roundedWaterLevel);
      setUnit(findInput.rawUnit);

      const newTimestamp = extractTimestampIfLevelExists(
        messages,
        assetAssignedTag?.assignedTagId!!
      );
      if (newTimestamp) {
        setTimestamp(newTimestamp);
      }
    }
  }, [findInput, messages, assetAssignedTag?.assignedTagId]);

  return {
    waterLevel: waterLevel !== null ? Number(waterLevel.toFixed(1)) : null,
    height: assetProperty?.value ? Number(assetProperty?.value) : Number(waterLevel),
    alarms,
    timestamp,
    unit,
  };
};
